import type { api } from './api';
import type { DocumentItem, Lead, LeadActivity } from '../types';

export interface LeadDetailState {
  lead: Lead | null;
  activities: LeadActivity[];
  documents: DocumentItem[];
  detailError: string;
  activitiesError: string;
  documentsError: string;
}

function sectionError(section: string, reason: unknown): string {
  const message = reason instanceof Error ? reason.message : 'Reîncercați încărcarea.';
  return `${section}: ${message}`;
}

export async function loadLeadDetail(id: string, client: Pick<typeof api, 'lead' | 'leadActivities' | 'leadDocuments'>): Promise<LeadDetailState> {
  // Un refuz pentru o secțiune nu invalidează datele citite din celelalte secțiuni.
  const [detail, activities, documents] = await Promise.allSettled([
    client.lead(id), client.leadActivities(id), client.leadDocuments(id),
  ]);
  const payload = activities.status === 'fulfilled' ? activities.value : undefined;
  const lead = detail.status === 'fulfilled' ? detail.value?.item || detail.value?.row || detail.value : null;
  const validLead = lead && typeof lead === 'object' && !Array.isArray(lead) && String(lead._id || lead.id || '') === id;
  return {
    lead: validLead ? lead : null,
    activities: Array.isArray(payload) ? payload : payload?.items || payload?.rows || [],
    documents: documents.status === 'fulfilled' ? documents.value : [],
    detailError: detail.status === 'rejected' ? sectionError('Lead-ul nu poate fi încărcat', detail.reason) : validLead ? '' : 'Lead-ul nu poate fi încărcat: răspuns invalid. Reîncercați.',
    activitiesError: activities.status === 'rejected' ? sectionError('Activitățile nu pot fi încărcate', activities.reason) : '',
    documentsError: documents.status === 'rejected' ? sectionError('Fotografiile nu pot fi încărcate', documents.reason) : '',
  };
}
